define('bizzabo/models/Polls',['bizzabo/bzapi', 'bizzabo/models/SyncedCollection', 'bizzabo/models/Poll', 'underscore'], function(BZAPI, SyncedCollection, Poll, _) {

    var Polls = SyncedCollection.extend({

        model : Poll,

        sync : function(method, model, options) {

            var thisEventId = this.eventId;
            if (method === 'read') {
                BZAPI.getPollsList(thisEventId, function(data) {
                    model.assimilateJson(data);
                    options.success && options.success(model.models, options);
                    model.setFlagsAfterSync();
                    model.setQuestionsIndices();
                    model.shouldFetch = false;
                }, options.error);
            } else if (method === 'update') {
                BZAPI.updatePollsList(thisEventId, {polls: {poll:model.toJSON()}}, function(data) {
                    model.assimilateJson(data);
                    options.success && options.success(model.models, options);
                    model.shouldFetch = false;
                    model.wasChanged = false;
                }, options.error);
            }
        },

        initialize : function() {

        },

        validate : function() {
            var isValid = true;
            this.each(function(poll) {
                isValid = poll.isAllModelValid(true) && isValid;
            });
            return isValid;
        },

        save : function(options) {
            var emptyFunction = function() {
            };
            options = options || {};
            options.error = options.error || emptyFunction;
            this.sync('update', this, options);
        },

        setQuestionsIndices : function() {
            _.each(this.models, function(poll) {
                poll.setQuestionsIndices();
            });
        },

        updatePollsOrder : function(options) {
            var pollsOrder = _.map(this.models, function(model){
                return {
                    id: model.id
                };
            });

            BZAPI.updatePollsOrder(this.eventId, {polls: {poll: pollsOrder}}, function(data) {
                options.success && options.success(options);
            }, options.error);
        }

    });

    return Polls;
});

